export default "__VITE_ASSET__cd30636e__"